export default __webpack_public_path__ + "static/media/meet.e0929ae7.svg";